import React from "react";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((_theme) => ({
    popupElement: {
        width: "100%",
        marginTop: 20,
    },
}));

export default function CallNote(props) {
    const { t } = useTranslation("translation");
    const classes = useStyles();
    return (
        <TextField
            id="bl_table_TextField_10"
            onChange={props.FilterWithCallNote}
            defaultValue={props.callNote}
            value={!props.callNote || props.callNote === "null" ? "" : props.callNote}
            label={t("CallNote")}
            variant="outlined"
            size={props.size ?? "normal"}
            className={classes.popupElement}
        />
    );
}
